var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropIcondash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67325_6021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.21338 15.6822C5.66614 15.6822 6.03369 15.3147 6.03369 14.8619C5.99311 13.7751 4.43348 13.7753 4.39307 14.8619C4.39307 15.3147 4.76068 15.6822 5.21338 15.6822Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.9707 19.5782C7.42346 19.5782 7.79102 19.2107 7.79102 18.7579C7.75044 17.6711 6.1908 17.6713 6.15039 18.7579C6.15039 19.2107 6.51795 19.5782 6.9707 19.5782Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33496 22.214C4.78772 22.214 5.15527 21.8465 5.15527 21.3937C5.1147 20.3068 3.55506 20.3071 3.51465 21.3937C3.51465 21.8465 3.8822 22.214 4.33496 22.214Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60693 16.5611C10.0597 16.5611 10.4272 16.1936 10.4272 15.7408C10.3867 14.654 8.82704 14.6542 8.78662 15.7408C8.78662 16.1936 9.15418 16.5611 9.60693 16.5611Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.66504 20.5151C9.66504 20.9679 10.0326 21.3354 10.4854 21.3354C11.5722 21.2949 11.5719 19.7352 10.4854 19.6948C10.0326 19.6948 9.66504 20.0623 9.66504 20.5151Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.1797 10.5272H14.8203V8.71161C14.78 7.62437 13.2197 7.62519 13.1797 8.71161V10.5272H0.820312C0.367281 10.5272 0 10.8945 0 11.3475V24.5272C0 24.9803 0.367281 25.3475 0.820312 25.3475H13.1797V27.1632C13.22 28.2504 14.7803 28.2496 14.8203 27.1632V25.3475H27.1797C27.6327 25.3475 28 24.9803 28 24.5272V11.3475C28 10.8945 27.6327 10.5272 27.1797 10.5272ZM13.1797 23.7069H1.64062V12.1679H13.1797V23.7069ZM26.3594 23.7069H14.8203V12.1679H26.3594V23.7069Z",
    fill: "#3B82F6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72803 6.89599C9.18106 6.89599 9.54834 6.52871 9.54834 6.07567C9.75238 0.312596 17.9556 0.121026 18.4456 5.84675L18.0945 5.49566C17.7742 5.1753 17.2548 5.1753 16.9344 5.49566C16.6141 5.81602 16.6141 6.33539 16.9344 6.65575L18.6917 8.41302C19.012 8.73338 19.5315 8.73338 19.8518 8.41302L21.6091 6.65575C21.9294 6.33539 21.9294 5.81602 21.6091 5.49566C21.2888 5.1753 20.7693 5.1753 20.449 5.49566L20.0877 5.85692C19.5228 -2.0551 8.19351 -1.86249 7.90771 6.07573C7.90771 6.52871 8.275 6.89599 8.72803 6.89599Z",
    fill: "#3B82F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67325_6021"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropIcondash);
export default __webpack_public_path__ + "static/media/DropIcondash.74ba42130b9379ed1aeb4f62cb5b9ac5.svg";
export { ForwardRef as ReactComponent };